// extracted by mini-css-extract-plugin
module.exports = {"form":"TextMeApp_form__ThrKU","btn":"TextMeApp_btn__Q9Bsi","mobile":"TextMeApp_mobile__iiAcz","downlaodBtn":"TextMeApp_downlaodBtn__0sD5D"};